import React from 'react';
import { useParams } from 'react-router-dom';
import ApiKeysPage from './ApiKeysPage';

// /brands/:id/api-keys — the internal brand detail page's API Keys tab:
// the same page brand admins see under Settings, scoped to the brand in
// the URL so staff can see and manage a client's keys.
export default function BrandDetailApiKeysTab() {
  const { id } = useParams();
  const brandId = id ? parseInt(id, 10) : 0;
  if (!brandId) return null;
  return <ApiKeysPage brandId={brandId} />;
}
